import * as React from 'react';
import { OTPInput, OTPInputContext } from 'input-otp';
import PropTypes from 'prop-types';
import { cn } from '@/common-utils/libraries/tailwind/utils';

const InputOTP = React.forwardRef(({ className, containerClassName, ...props }, ref) => (
    <OTPInput
        ref={ref}
        containerClassName={cn(
            'flex items-center gap-2 has-[:disabled]:opacity-50',
            containerClassName
        )}
        className={cn('disabled:cursor-not-allowed', className)}
        {...props}
    />
));
InputOTP.displayName = 'InputOTP';

const InputOTPGroup = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center', className)} {...props} />
));
InputOTPGroup.displayName = 'InputOTPGroup';

const InputOTPSlot = React.forwardRef(({ index, className, ...props }, ref) => {
    const inputOTPContext = React.useContext(OTPInputContext);
    const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

    return (
        <div
            ref={ref}
            className={cn(
                'relative flex h-12 w-12 items-center justify-center border-y border-r border-input text-xl shadow-sm transition-all font-bold text-blue500',
                'first:rounded-l-md first:border-l last:rounded-r-md',
                isActive && 'z-10 ring-1 ring-ring',
                className
            )}
            {...props}
        >
            {char}
            {hasFakeCaret && (
                <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
                    <div className='h-4 w-px animate-caret-blink bg-foreground duration-1000' />
                </div>
            )}
        </div>
    );
});
InputOTPSlot.displayName = 'InputOTPSlot';

const InputOTPSeparator = React.forwardRef(({ className, ...props }, ref) => (
    <hr
        ref={ref}
        className={cn('border-t border-gray-300 my-2', className)}
        {...props}
    />
));
InputOTPSeparator.displayName = 'InputOTPSeparator';

InputOTP.propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string
};

InputOTPGroup.propTypes = {
    className: PropTypes.string
};

InputOTPSlot.propTypes = {
    index: PropTypes.number,
    className: PropTypes.string
};

InputOTPSeparator.propTypes = {
    className: PropTypes.string
};

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };
